import API from "../../../../api/index";
import React, { useState, useEffect } from "react";
import { Box, Typography } from "@mui/material";
import "react-pro-sidebar/dist/css/styles.css";
import CircularIndeterminate from "../../../../components/circularProgress";
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import TroubleshootIcon from '@mui/icons-material/Troubleshoot';
import BarCharts from "./barCharts";


function determinaFreccia(categorie, raggruppamento) {
  return categorie.map(categoria => `${categoria}`);
}

const GroupedChart = ({ filter }) => {
  const [, setApiData] = useState()
  const [series, setSeries] = useState()
  const [charged, setCharged] = useState(false)

  useEffect(() => {
    let date = new Date();
    let lastTenDays = [];
    for (let i = 1; i <= 14; i++) {
      let dataFormat = date.toISOString().split('T')[0];
      lastTenDays.push(dataFormat);
      date.setDate(date.getDate() - 1);
    }
    API.getAdvancedData((filter.tipo.length !== 0 || filter.dateFrom || filter.dateTo || filter.dettaglio.length !== 0 || filter.ip1 || filter.ip2) ? { ...filter, dateFrom: (filter.dateFrom ? filter.dateFrom : lastTenDays[0]), dateTo: (filter.dateTo ? filter.dateTo : lastTenDays[lastTenDays.length -1]) } : filter.smartFilter ? { ...filter } : { ...filter, dateFrom: (filter.dateFrom ? filter.dateFrom : lastTenDays[0]), dateTo: (filter.dateTo ? filter.dateTo : lastTenDays[lastTenDays.length -1]) }).then((response) => {
      let raggruppamento = {};
      response.data.forEach(elemento => {
        let dettaglio = elemento._id.dettaglio;
        let timeStamp = elemento._id.timeStamp;
        let count = elemento.count;

        if (!raggruppamento[dettaglio]) {
          raggruppamento[dettaglio] = {};
        }

        if (!raggruppamento[dettaglio][timeStamp]) {
          raggruppamento[dettaglio][timeStamp] = 0;
        }

        raggruppamento[dettaglio][timeStamp] += count;
      });

      var categorie = Object.keys(raggruppamento);
      const dateUniche = [...new Set(categorie.flatMap(dettaglio => Object.keys(raggruppamento[dettaglio])))].sort();

      const serie = dateUniche.map(data => ({
        name: data,
        data: categorie.map(dettaglio => raggruppamento[dettaglio][data] || 0)
      }));

      categorie = determinaFreccia(Object.keys(raggruppamento), raggruppamento);

      // Aggiungi l'array details a ciascun oggetto in serie
      serie.forEach((s) => {
        s.details = categorie;
      });

      setSeries(serie);
      setCharged(true)
      setApiData(response.data);
    }).catch(err => {
      console.error(err)
      setCharged(true)
    });
  }, [filter]);

  return (
    <Box
      sx={{
        width: '99%', height: '100%', paddingTop: 3,
        overflow: "auto", alignItems: "center", justifyContent: "center", display: "flex", flexDirection: "column",
      }}
    >
      {series && series.length ? <>
        <Typography sx={{ fontSize: 25, fontWeight: 900 }}>Grouped Chart</Typography>
        <BarCharts rawData={series} />
      </> :
        !charged ? <CircularIndeterminate charged={charged} title="No data" /> :
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 5, color: 'grey' }}>
            <Typography fontWeight={900} variant="h3">No data in last week</Typography>
            <div>
              <FilterAltIcon sx={{ fontSize: 100 }} />
              <TroubleshootIcon sx={{ fontSize: 90, position: 'absolute', marginLeft: -6, marginTop: 4 }} />
            </div>
            <Typography fontWeight={600} variant="h4">Select or drag and drop here other filters </Typography>
          </Box>
      }
    </Box>
  );
};

export default GroupedChart;